import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import FMPSectionCard from '../../components/ui/FMPSectionCard';
import PooledIcon from '../../images/icons/pooledLoadingNumbers.png';
import AssignedIcon from '../../images/icons/assignedLoadingNumbers.png';

const styles = (theme) => ({
	masthead: {
		textAlign: 'left',
		fontSize: 24,
		color: '#666',
		letterSpacing: 0,
		textTransform: 'uppercase',
		fontWeight: 300,
		marginBottom: 15,
		marginTop: 15,
		position: 'relative',
		marginLeft: 0,
		[theme.breakpoints.up('sm')]: {
			fontSize: 22,
		},
		[theme.breakpoints.up('md')]: {
			fontSize: 30,
		},
	},
});

class LoadingNumbersDashboard extends Component {
	render() {
		const { classes } = this.props;
		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<div className={classes.masthead}>Loading Numbers</div>
				</Grid>

				<Grid item xs={12} sm={6}>
					<FMPSectionCard
						title={'Pooled Loading Numbers'}
						icon={PooledIcon}
						description={`A pool of one time use loading numbers per terminal and supplier.
						Import a batch from the supplier and FMP hands out the next available number
						each time an E85 order is activated. You get an email when a pool runs low.`}
						url={'/logistics/loadingAssignments/pooled'}
					/>
				</Grid>

				<Grid item xs={12} sm={6}>
					<FMPSectionCard
						title={'Assigned Loading Numbers'}
						icon={AssignedIcon}
						description={`A fixed loading number per station and fuel type at a terminal
						(Petro-Diamond, IECFT). Pick a terminal, manage the station list, import the
						supplier's master list or export ours. Orders at that terminal pull the station's
						number automatically and warn when one is missing.`}
						url={'/logistics/loadingAssignments/assigned'}
					/>
				</Grid>
			</Grid>
		);
	}
}

LoadingNumbersDashboard.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles)])(LoadingNumbersDashboard);
